import { mapGetters } from 'vuex';
import Service from '../service';
import UploadImage from '../../socialized-service/share/upload-image/index.vue';
const checkImage = (rule, value, callback) => {
  if (!value || !value.length) {
    return callback(new Error('请上传'));
  }
  callback();
};
export default {
  components: {
    UploadImage
  },
  data() {
    return {
      typeList: [],
      fieldList: [],
      tId: '66aaf74f247b9fffdb5eba08',
      form: {
        type: null,
        subType: null,
        fieldList: []
      },
      rules: {
        type: [
          { required: true, message: '请选择产品类型', trigger: 'change' }
        ]
      },
      templateId: '',
      submitStatus: 'init',
      defaultImages: []
    };
  },
  created() {
    this.form.subType = this.$route.query.subType;
    Service.getSubTypeList().then(res => {
      this.typeList = res;
    });
    // this.getFieldList();
  },
  computed: {
    ...mapGetters([
      'userType'
    ])
  },
  methods: {
    back() {
      this.$router.back();
    },
    getRules(element) {
      if (element.type === 'input') {
        return [{ required: true, message: '请输入' + element.title, trigger: ['blur', 'change'] }];
      } else if (element.type === 'select') {
        return [{ required: true, message: '请选择' + element.title, trigger: 'change' }];
      } else if (element.type === 'images') {
        return [{ required: true, validator: checkImage, message: '请上传' + element.title, trigger: 'change' }];
      }
      return {};
    },
    getFieldList() {
      Service.getFieldList({ type: this.form.type, subType: this.form.subType, tId: this.tId }).then(res => {
        const result = res.result.length ? res.result[0] : {};
        this.templateId = result._id;
        this.form.fieldList = result.fields;
        this.defaultImages = [];
      });
    },

    uploadSuccessImage(image, item) {
      item.value = image;
    },

    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.form.fieldList.length) {
            this.$errorMessage('请完善信息');
            return;
          };
          this.submitStatus = 'ongoing';
          let payload = {
            templateId: this.templateId,
            subType: this.form.subType,
            tId: this.tId,
            type: this.form.type
          };
          this.form.fieldList.forEach(element => {
            payload[element.key] = element.value;
          });
          Service.createDemand(payload).then(() => {
            this.$successMessage('提交成功');
            this.$router.back();
          }, error => {
            this.$errorMessage(error.data.reason || '提交失败');
          }).finally(() => {
            this.submitStatus = 'init';
          });
        }
      });
    }
  }

};
